export default
	[
		{
			path: '',
			redirect: 'shipOwnerManagement'
		},
		// 船主
		{
			path: 'shipOwnerManagement',
			name: 'shipOwnerAndShipCenter/shipOwnerManagement',
			component: () => import('@/page/shipOwnerAndShipCenter/shipOwnerManagement'),
			meta: { openKeyName: '船主', selectKeyUrl: 'shipOwnerManagement' }
		},
		{
			path: 'shipOwnerManagement/:id',
			name: 'shipOwnerAndShipCenter/shipOwnerManagement/detail',
			component: () => import('@/page/shipOwnerAndShipCenter/shipOwnerManagementDetail'),
			meta: { openKeyName: '船主', selectKeyUrl: 'shipOwnerManagement' },
			props: true
		},
		// 船舶
		{
			path: 'shipManagement',
			name: 'shipOwnerAndShipCenter/shipManagement',
			component: () => import('@/page/shipOwnerAndShipCenter/shipManagement'),
			meta: { openKeyName: '船舶', selectKeyUrl: 'shipManagement' }
		},
		{
			path: 'shipManagement/:id',
			name: 'shipOwnerAndShipCenter/shipManagement/detail',
			component: () => import('@/page/shipOwnerAndShipCenter/shipManagementDetail'),
			meta: { openKeyName: '船舶', selectKeyUrl: 'shipManagement' },
			props: true
		},
		{
			path: 'shipTrackAndPositioning',
			name: 'shipOwnerAndShipCenter/shipTrackAndPositioning',
			component: () => import('@/page/shipOwnerAndShipCenter/shipTrackAndPositioning'),
			meta: { openKeyName: '船舶', selectKeyUrl: 'shipTrackAndPositioning' }
		}
	]



// WEBPACK FOOTER //
// ./src/router/shipOwnerAndShipCenter/index.js